import NewUsersReceipt from "../../team/ModalScreens/NewUsersReceipt";
import StepWrapper from "../StepWrapper";

export default function TeamReceiptStep({ receiptData }) {
  return (
    <StepWrapper
      title="Team Setup Complete! 🎉"
      description="Your team has been created and invitations have been sent. Here's a summary of what happened:"
    >
      <NewUsersReceipt
        receiptData={receiptData}
        isPartOfOrganization={false}
        onboardingMode={true}
      />
    </StepWrapper>
  );
}
